import { IValidationSchema } from '@centerhealth/types';

export const PERSONAL_VALIDATION_SCHEMA: IValidationSchema = {
  fields: {
    firstName: {
      type: 'string',
      label: 'First name',
      required: true,
      trim: true,
      maxlength: 50,
    },
    lastName: {
      type: 'string',
      label: 'Last name',
      required: true,
      trim: true,
      maxlength: 50,
    },
  },
};

export const BIRTHDAY_VALIDATION_SCHEMA: IValidationSchema = {
  fields: {
    birthday: {
      type: 'date',
      label: 'Date of birth',
      required: true,
      min: '1900-01-01',
      max: 'today',
    },
  },
};

export const EMAIL_VALIDATION_SCHEMA: IValidationSchema = {
  fields: {
    email: {
      label: 'Email',
      type: 'string',
      required: true,
      trim: true,
      lowercase: true,
      validate: 'email',
    },
  },
};

export const PASSWORD_VALIDATION_SCHEMA: IValidationSchema = {
  fields: {
    password: {
      label: 'Password',
      type: 'string',
      required: true,
      minlength: 6,
    },
  },
};

export const INVITECODE_VALIDATION_SCHEMA: IValidationSchema = {
  fields: {
    invitationCode: {
      label: 'Invite code',
      type: 'string',
      required: false,
      minlength: 6,
      maxlength: 24,
    },
  },
};

export const CM_HEIGHT_VALIDATION_SCHEMA: IValidationSchema = {
  fields: {
    value: {
      type: 'number',
      subType: 'float',
      required: true,
      maxPrecision: 0,
      min: 50,
      max: 280,
      label: 'height (cm)',
    },
    unit: {
      type: 'string',
      required: true,
      label: 'unit',
    },
  },
};

export const FEET_HEIGHT_VALIDATION_SCHEMA: IValidationSchema = {
  fields: {
    ft: {
      type: 'number',
      subType: 'integer',
      required: true,
      maxPrecision: 0,
      min: 1,
      max: 9,
      validate: 'feet',
      label: 'height (feet)',
    },
    inches: {
      type: 'number',
      subType: 'integer',
      required: true,
      maxPrecision: 0,
      min: 0,
      max: 11,
      label: 'height (inches)',
    },
    unit: {
      type: 'string',
      required: true,
      label: 'unit',
    },
  },
};
